import React, { FC } from 'react';
import classnames from 'classnames';

import { useAnnounceI18n } from '@/shared/hooks/useAnnouncePromiseI18n';

import styles from './AnnounceContent.module.css';

interface Props {
    className?: string;
    announcePromise: string | null;
    availabilityDate: string | null;
}

export const AnnounceContent: FC<Props> = ({ announcePromise, availabilityDate, className }) => {
    const { getAnnounceText } = useAnnounceI18n();

    const announceText = getAnnounceText(availabilityDate || '', announcePromise || '');

    return (
        <div className={classnames(styles.root, className)}>
            <span className={styles.announceText}>{announceText}</span>
        </div>
    );
};
